import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from './../../models/id-name.model';
import { PpReportSubject } from './../../enums/pp-report-subject.enum';

@Pipe({
  name: 'ppReportSubject',
  standalone: false
})
export class PpReportSubjectPipe implements PipeTransform {
  public transform(value: PpReportSubject): string {
    return getPpReportSubject(value);
  }
}

export function getPpReportSubject(value: PpReportSubject): string {
  switch (value) {
    case PpReportSubject.Program:
      return 'Program';
    case PpReportSubject.Employee:
      return 'Employee';
    case PpReportSubject.Supervisor:
      return 'Supervisor';
    default:
      throw new Error(`Unsupported value for PpReportSubject: ${value}.`);
  }
}

export function getPpReportSubjectList(): IdName[] {
  return enumToList(PpReportSubject, getPpReportSubject);
}
